export function ttsGetTextBlockSelector(id: string | undefined) {
  return `${id}-tts-text`;
}
